import { Notification } from 'element-ui';

export function notify({ title = '', message = '', type = 'info' }) {
  Notification({ title, message, type });
}

export function handleError(err, msg = '發生錯誤') {
  console.error(err);
  notify({ title: '錯誤', message: msg, type: 'error' });
}
